module.exports = __webpack_public_path__ + "img/jiaoqiu.5c8753e3.png";